define('home/views/ChannelModeratorsView',[
    'backbone-marionette',

    'home/views/ChannelModeratorUserView',
    'home/views/ChannelModeratorFormView',

    'home/mixins/withSubviews',
    'home/templates/channelModerators',
], function (
    Marionette,

    ChannelModeratorUserView,
    ChannelModeratorFormView,

    withSubviews,
    channelModeratorsTemplate
) {
    'use strict';

    var ChannelModeratorsView = Marionette.ItemView.extend({
        template: channelModeratorsTemplate,
        className: 'card-wrap',

        regions: {
            moderatorsRegion: '[data-role=moderators]',
            moderatorFormRegion: '[data-role=moderator-form]',
        },

        onRender: function () {
            this.activateRegion(this.moderatorsRegion, this.createModeratorsView);
            this.activateRegion(this.moderatorFormRegion, this.createModeratorFormView);
        },

        createModeratorsView: function () {
            return new Marionette.CollectionView({
                itemView: ChannelModeratorUserView,
                itemViewOptions: {
                    channel: this.model.channel,
                },
                collection: this.model.moderators.items,
            });
        },

        createModeratorFormView: function () {
            return new ChannelModeratorFormView({
                model: this.model,
            });
        },
    });

    withSubviews.call(ChannelModeratorsView.prototype);

    return ChannelModeratorsView;
});

